export class ConfirmState {
    isOpen: boolean = false;
    instanceId = 0;
    ownerId?: string;
    onDismiss?: (reason: ConfirmDismissReason) => void;
    acceptDisabled?: () => boolean;
    defaultButton: 'accept' | number = 'accept';
    distinguishFocusedButton = false;
    width: number = 400;
    contentClasses: string[] = [];

    acceptBtnText = '';
    cancelBtnText = '';
    isHideCancelBtn = false;

    acceptBtnColor = '';
    acceptBtnClasses: string[] = [];

    extraButtons: ExtraButton[] = [];
    extraHtmlAfterButtons?: string = '';
    /** Optional buttons rendered directly after the accept button (e.g. "Save and don't ask again"). */
    acceptSideButtons: ExtraButton[] = [];

    title: string = '';
    message: string = '';
    attach: string | boolean = false;

    acceptFn?: () => void = null;
    cancelFn?: () => void = null;
}

export interface ExtraButton {
    class?: string;
    color?: string;
    text: string;
    callbackFn: () => void;
    disabled?: () => boolean;
}

export type ConfirmDismissReason = 'dismissed' | 'superseded' | 'disposed';
